<ng-container *ngIf="isVisible">
  <span *ngIf="isIncreased" [ngClass]="{ up: projectedIncrease > 0, down: projectedIncrease < 0 }">&#9650;</span>
  <span *ngIf="!isIncreased" [ngClass]="{ up: projectedIncrease > 0, down: projectedIncrease < 0 }">&#9660;</span>
  <hf-currency [value]="projectedIncrease"></hf-currency>
</ng-container>
